var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import layoutComponentsDictionary from "../../layout/layoutComponentsDictionary";
/**
 * List component of Etc field
 *
 * @param param0
 */
export function EtcFieldList(_a) {
    var meta = _a.meta;
    var fieldName = function () {
        var m = meta || {};
        var s = m.settings || {};
        return s.field || "";
    };
    return (_jsx(_Fragment, { children: _jsxs("span", __assign({ className: "flex flex-row items-center" }, { children: [_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-4 h-4" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6 h-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" }) })) })), _jsxs("span", __assign({ className: "ml-2" }, { children: [fieldName() && (_jsx("span", __assign({ className: "font-bold" }, { children: "".concat(fieldName(), " - ") }))), "ETC-FIELD"] }))] })) }));
}
layoutComponentsDictionary.registerLayoutComponent("etc-field-list", EtcFieldList);
